import AppSong from '/music/dokidoki[music].mp3';
import { useEffect, useRef, useState } from 'react';
import { FaPause, FaPlay } from 'react-icons/fa';

const MediaPlayer = () => {
  const audioRef = useRef(new Audio(AppSong));
  const [isPlaying, setIsPlaying] = useState(false);
  useEffect(() => {
    // Add this state
    const audio = audioRef.current;
    audio.loop = true;
    audio.volume = 0.05;
    audio.muted = true;

    // Unmute on first click
    const unmute = () => {
      audio.muted = false;
      audio.play();
      setIsPlaying(true);
      document.removeEventListener('click', unmute);
    };

    document.addEventListener('click', unmute);

    return () => {
      audio.pause();
      audio.remove(); // Properly cleanup the audio element
      document.removeEventListener('click', unmute);
    };
  }, []);
  const togglePlay = () => {
    const audio = audioRef.current;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <>
      <img
        alt="vinilDisc"
        src={'/vinilDisc.svg'}
        className={`${isPlaying ? 'animate-spin' : ''} fixed right-4 bottom-4 md:right-8 md:bottom-8 z-50 w-12 h-12 md:w-14 md:h-14`}
      />

      <button
        onClick={togglePlay}
        className="fixed right-14 bottom-12 md:right-20 md:bottom-20 z-50 
           w-4 h-4 hover:bg-black
            rounded-lg backdrop-blur-sm
            flex items-center justify-center
            border border-white/10 hover:border-white/20
            shadow-lg hover:shadow-xl
            transition-all duration-300 ease-in-out
            group"
        aria-label={isPlaying ? 'Pause music' : 'Play music'}
      >
        {isPlaying ? (
          <FaPause className="text-white/80 group-hover:text-white text-xl md:text-2xl" />
        ) : (
          <FaPlay className="text-white/80 group-hover:text-white text-xl md:text-2xl" />
        )}
      </button>
    </>
  );
};

export default MediaPlayer;
